import { get, toUpper } from 'lodash';
import NSApplicationStatus from '../../Constants/ns-vendor-application-status';
import ApplicationStatus from '../../Constants/vendor-application-status';

/**
 * Gets the status of the Vendor Application based on the Vendor object passed in
 * @param {object} vendor the vendor returned from the database
 *
 * @returns {string} the status of the application
 */
export default function getApplicationStatus(vendor) {
  if (vendor?.application_archived_at) {
    return ApplicationStatus.ARCHIVE;
  }

  const status = get(vendor, 'application_status');
  if (
    vendor.approved_at &&
    vendor.submitted_at &&
    status !== NSApplicationStatus.APPROVED &&
    status !== NSApplicationStatus.REJECTED
  ) {
    return ApplicationStatus.PENDING_ACCOUNTING_APPROVAL;
  }
  if (toUpper(vendor.application_status) === ApplicationStatus.REJECTED) {
    return ApplicationStatus.REJECTED;
  }
  if (
    (vendor.submitted_at && !vendor.internal_id) ||
    (vendor.submitted_at && vendor.rejection_reason) ||
    status === NSApplicationStatus.PENDING_APPROVAL ||
    status === NSApplicationStatus.PENDING_RE_APPROVAL
  ) {
    return ApplicationStatus.PENDING_APPROVAL;
  }
  if (vendor.internal_id) {
    return ApplicationStatus.APPROVED;
  }
  return ApplicationStatus.APPLICATION_PENDING;
}
